/* =================== DEPOIMENTOS =================== */
$(function () {
  const slideItems = $(".carrosel-depoimentos .depoimento-wrp").length;
  const slideDots = slideItems > 2;
  $(".carrosel-depoimentos").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    arrows: false,
    dots: slideDots,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          adaptiveHeight: true,
        },
      },
    ],
  });
});
